import {
  addDays,
  differenceInCalendarDays,
  isAfter,
  isBefore,
  startOfDay,
} from "date-fns"

import { utcToZonedTime } from "date-fns-tz"

export interface FormatOptions extends Intl.DateTimeFormatOptions {
  dateStyle?: "full" | "long" | "medium" | "short"
  timeStyle?: "full" | "long" | "medium" | "short"
}

export function elapsedTime(
  end: string,
  start: string,
  timezone: string,
): number {
  const now = startOfDay(utcToZonedTime(new Date(), timezone))
  const earlier = utcToZonedTime(start, timezone)
  const later = utcToZonedTime(end, timezone)

  // not started yet
  if (now.getTime() < earlier.getTime()) {
    return 0
    // stupid
  } else if (earlier.getTime() > later.getTime()) {
    return 0
    // finished
  } else if (now.getTime() > later.getTime()) {
    return 100
    // elapsed
  } else {
    const total = differenceInCalendarDays(addDays(later, 1), earlier)
    let elapsed = differenceInCalendarDays(now, earlier)
    // adjust for the situation when the current date (now) is the same as the start date
    elapsed = now.getTime() >= earlier.getTime() ? elapsed + 1 : elapsed
    const progress = Math.round((elapsed / total) * 100)
    return progress
  }
}

const short_distance_tokens: Record<string, string> = {
  lessThanXSeconds: "s",
  xSeconds: "s",
  halfAMinute: "m",
  lessThanXMinutes: "m",
  xMinutes: "m",
  aboutXHours: "h",
  xHours: "h",
  xDays: "d",
  aboutXWeeks: "w",
  xWeeks: "w",
  aboutXMonths: "mo",
  xMonths: "mo",
  aboutXYears: "y",
  xYears: "y",
  overXYears: "y",
  almostXYears: "y",
}

export function formatDistanceShort(token: string, count: number | null) {
  return `${count || 0}${short_distance_tokens[token] || ""}`
}

export function isDateBetween(givenDate: Date, start: Date, end: Date) {
  const isAfterStart = isAfter(givenDate, start)
  const isBeforeEnd = isBefore(givenDate, end)

  return isAfterStart && isBeforeEnd
}

export const date_display_format_obj = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
} as Intl.DateTimeFormatOptions

export const range_display_format_string = "d MMM yyyy"

export const range_display_format_obj = {
  day: "numeric",
  month: "short",
  year: "numeric",
} as Intl.DateTimeFormatOptions

export const removeLocaleTzOffset = (date?: Date | null) => {
  const offset =
    !!date && date instanceof Date ? date.getTimezoneOffset() * 10000 * 6 : 0
  return !!date ? new Date(date.getTime() - offset) : new Date()
}

export const addLocaleTzOffset = (date?: Date | null) => {
  const offset =
    !!date && date instanceof Date ? date.getTimezoneOffset() * 10000 * 6 : 0
  return !!date ? new Date(date.getTime() + offset) : new Date()
}

export const nextDay = (date: Date) =>
  !!date ? new Date(date.getTime() + 24 * 60 * 60 * 1000) : new Date()

export const previousDay = (date: Date) =>
  !!date ? new Date(date.getTime() - 24 * 60 * 60 * 1000) : new Date()
